export default "__VITE_ASSET__DJlKr6LX__"